import { render } from "./TripReportDetails.vue?vue&type=template&id=5dd107d6"
import script from "./TripReportDetails.vue?vue&type=script&lang=js"
export * from "./TripReportDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__